<div class="relative inline-block" [style.min-width]="minWidth">
  <!-- Full-viewport click-catcher to close the dropdown on outside
       click. z-0 sits behind the panel itself. -->
  <div *ngIf="open" class="fixed inset-0 z-0" (click)="open = false"></div>

  <div class="flex items-center border border-gray-300 dark:border-[#434863] bg-white dark:bg-app-black-100 rounded overflow-hidden">
    <input
      #inputEl
      type="text"
      class="flex-1 bg-transparent text-gray-900 dark:text-white px-2 py-1 text-xs font-mono outline-none"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [ngModel]="filterText"
      (ngModelChange)="onInput($event)"
      (focus)="onFocus()"
      (keydown)="onKey($event)"
    />
    <button *ngIf="filterText" type="button"
            class="px-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
            (click)="clear()"
            title="Clear">
      <i class="fa-solid fa-xmark text-xs"></i>
    </button>
    <button type="button"
            class="px-2 py-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 border-l border-gray-300 dark:border-[#434863]"
            (click)="open = !open"
            [disabled]="disabled">
      <i class="fa-solid fa-caret-down text-xs"></i>
    </button>
  </div>

  <div *ngIf="open"
       class="absolute left-0 z-10 mt-1 w-full min-w-[280px] max-h-72 overflow-y-auto rounded border border-gray-200 dark:border-[#434863] bg-white dark:bg-app-black-100 shadow-lg text-xs">
    <div *ngIf="filteredItems.length === 0"
         class="px-3 py-2 text-gray-500 dark:text-gray-400 italic">
      No matches for "{{ filterText }}"
    </div>
    <button *ngFor="let it of filteredItems; let i = index; trackBy: trackByItem"
            type="button"
            class="w-full text-left px-3 py-1.5 font-mono transition"
            [class.bg-app-blue-100]="i === activeIndex"
            [class.dark:bg-app-blue-100]="i === activeIndex"
            [class.hover:bg-gray-50]="i !== activeIndex"
            [class.dark:hover:bg-app-blue-100]="i !== activeIndex"
            (click)="select(it)"
            (mouseenter)="activeIndex = i">
      <ng-container *ngFor="let seg of segmentsFor(it); trackBy: trackByIndex">
        <span [ngClass]="seg.match
                ? 'font-bold text-app-teal-100'
                : 'text-gray-900 dark:text-white'">{{ seg.text }}</span>
      </ng-container>
    </button>
  </div>
</div>
